import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import compose from 'lodash/fp/compose';
import _ from 'lodash';
import { getList, getIsLoading } from 'src/reducers/common/listReducer';
import { TAX_DEDUCTION_CERT_EDIT_FORM } from 'src/constants/FormNames';
import { REDUCER_NAME } from 'src/reducers/year_end_reports/yearEndReportTaxDeductionCerts';
import TaxDeductionCertsTable from '../components/TaxDeductionCertsTable';

const EDITABLE_FIELDS = ['totalSsoAmount', 'totalCharityAmount', 'totalAssessableIncome', 'totalTaxableIncome', 'totalWithholdingTaxAmount'];

const buildInitialValues = employeePays =>
  (employeePays || []).reduce((acc, employee) => {
    acc[`emp_${employee.employeeId}`] = EDITABLE_FIELDS.reduce((fields, field) => {
      const raw = employee[field];
      return {
        ...fields,
        [field]: raw !== null && raw !== undefined ? String(raw) : ''
      };
    }, {});
    return acc;
  }, {});

const mapStateToProps = (state, ownProps) => {
  const unconfirmedMonthsState = _.get(state, `${REDUCER_NAME}.unconfirmedMonths.data`) || {};
  const employeePays = getList(REDUCER_NAME, state) || [];
  return {
    isListLoading: getIsLoading(REDUCER_NAME, state) || false,
    employeePays,
    initialValues: buildInitialValues(employeePays),
    isEditMode: ownProps.isEditMode,
    onSave: ownProps.onSave,
    onReset: ownProps.onReset,
    onSetResetForm: ownProps.onSetResetForm,
    onSetHandleSubmit: ownProps.onSetHandleSubmit,
    unconfirmedMonths: unconfirmedMonthsState
  };
};

export default compose(
  connect(mapStateToProps),
  reduxForm({
    form: TAX_DEDUCTION_CERT_EDIT_FORM,
    enableReinitialize: true,
    onSubmit: (values, _dispatch, props) => props.onSave(values)
  })
)(TaxDeductionCertsTable);
